var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "step_2" } }, [
    _c("img", {
      staticStyle: { "max-width": "500px" },
      attrs: { src: require("../img/cup-size.svg") },
    }),
    _vm._v(" "),
    _c("h2", [_vm._v("What's your cup size?")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.$root.cup_size,
            expression: "$root.cup_size",
            modifiers: { lazy: true },
          },
        ],
        staticClass: "form-control",
        attrs: {
          placeholder: "enter your cup size here",
          type: "number",
          min: _vm.$root.underbust_size,
          max: parseFloat(_vm.$root.underbust_size) + 18,
          step: "0.5",
          required: "",
        },
        domProps: { value: _vm.$root.cup_size },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.$root, "cup_size", $event.target.value)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n    To find your cup size, measure the snug measurement of\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    the fullest part of your breasts, shirt off, bra on.\n    "
      ),
      _c("br"),
      _vm._v(
        '\n    Round up to the nearest half inch; i.e. if you measure 32 1/4 inch, round up to 32.5" inches.\n  '
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }